import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Members Summary", -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  class: "col-md-9 dx-item-content dx-toolbar-item-content",
  style: {"min-width":"350px"}
}
const _hoisted_4 = {
  role: "group",
  class: "dx-buttongroup dx-widget",
  tabindex: "0"
}
const _hoisted_5 = { class: "dx-buttongroup-wrapper dx-widget dx-collection" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "dx-button-content" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "dx-icon dx-icon-chevronprev" })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  class: "dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text dx-item dx-buttongroup-item dx-item-content dx-buttongroup-item-content dx-shape-standard dx-scheduler-navigator-caption",
  role: "button",
  "aria-label": ""
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "dx-button-content" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "dx-icon dx-icon-chevronnext" })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "dx-button-content" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-check" }),
  /*#__PURE__*/_createTextVNode(" Today ")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "table table-hover" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "QC Members"),
  /*#__PURE__*/_createElementVNode("th", null, "Working"),
  /*#__PURE__*/_createElementVNode("th", null, "Set daily target"),
  /*#__PURE__*/_createElementVNode("th", null, "Capacity"),
  /*#__PURE__*/_createElementVNode("th", null, "Allocate"),
  /*#__PURE__*/_createElementVNode("th", null, "Review"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"250px !important"} }, "Summary"),
  /*#__PURE__*/_createElementVNode("th", null, "Issued"),
  /*#__PURE__*/_createElementVNode("th", null, "Outstanding")
], -1)
const _hoisted_15 = ["onUpdate:modelValue", "checked", "onChange"]
const _hoisted_16 = ["onUpdate:modelValue", "onInput", "onChange"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, /*#__PURE__*/_toDisplayString("test"), -1)

import { computed, inject, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { DxDateBox } from "devextreme-vue/date-box";
import { useStore } from "vuex";
import moment from "moment-timezone";
import { useToast } from "vue-toastification";
import Ably from "ably";
import { Booking, Qc, Qcmember } from "@/models";
import { Qcmemberdailytarget } from "@/models/qcmemberdailytarget.model";


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberSummary',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const _currentdate = computed(() => store.getters["diary/currentdate"]);

const getBookingsforQCMemberList = (
  payload?: { date?: string },
  p0?: () => void
) => {
  return store.dispatch("diary/getBookingsforQCMemberList", payload);
};
const qcnemberlist = ref([]);
const bookinglist = ref([]);
const qcdailymembertarget = ref([]);

const setCurrentdate = (currentdate: Date) => {
  store.commit("diary/setCurrentdate", currentdate);
};

const getBookingsforQCSummary = (
  payload?: { date?: string },
  p0?: () => void
) => {
  return store.dispatch("diary/getBookingsforQCSummary", payload);
};

const getQcDailyTarget = (payload?: { date?: string }, p0?: () => void) => {
  return store.dispatch("diary/getQcDailyTarget", payload);
};

const updateDailyTarget = async (qcdailymembertarget: Qcmemberdailytarget) => {
  return await store.dispatch("diary/updateDailyTarget", qcdailymembertarget);
}



class MemberSummaryData {
  id?: string = '';
  date?: string = '';
  working?: boolean = false;
  dailytarget?: number = 0;
  qcmember: Qcmember;
  capacity: number = 0;
  allocate: number = 0;
  review: string = '';
  issued: number = 0;
  outstanding: number = 0;
  inventory?: number;
  cosoc: number;
  ci: number;
  other: number;
  pv: number;
}

const currentdate = computed({
  get: () => _currentdate.value,
  set: (val) => {
    // Assuming setCurrentdate is an adapted method for Vue 3
    setCurrentdate(val);
  },
});

const prevdate = () => {
  currentdate.value = moment(currentdate.value)
    .utc()
    .subtract(1, "days")
    .toDate();
  //getBookingsforQCSummary({ date: formatDate(currentdate.value) }, () => {});
};

const nextdate = () => {
  currentdate.value = moment(currentdate.value).utc().add(1, "days").toDate();
  //getBookingsforQCSummary({ date: formatDate(currentdate.value) }, () => {});
};

const today = () => {
  currentdate.value = moment().utc().toDate();
  //getBookingsforQCSummary({ date: formatDate(currentdate.value) }, () => {});
};

const formatDate = (date: Date) => {
  return moment(date).format("DD-MM-YYYY");
};

onMounted(async () => {
  commonFunction();
});

const commonFunction = async () => {
  await getBookingsforQCMemberList({ date: "" }, () => {}).then(
    (t: Qcmember[]) => {
      qcnemberlist.value = t;
      getBookingsforQCSummary(
        { date: formatDate(currentdate.value) },
        () => {}
      ).then((bookings: Booking[]) => {
        bookinglist.value = bookings;
      });
      getQcDailyTarget({ date: formatDate(currentdate.value) }, () => {}).then(
        (qcdata: Qcmemberdailytarget[]) => {
          qcnemberlist.value.forEach((f: Qcmember, $index) => {
            let data = new MemberSummaryData();
            let index = qcdata.findIndex(
              (q: Qcmemberdailytarget) => q.qcmember.id === f.id
            );
            if (index === -1) {
              data.qcmember = f;
            } else {             
              data.qcmember = qcdata[index].qcmember;
              data.id = qcdata[index].id;
              data.working = qcdata[index].working;
              data.dailytarget = qcdata[index].dailytarget;
            }
            // capacity 
            if(data.dailytarget !== 0){
              data.allocate = bookinglist.value.filter((b: Booking) => {
                 return f.id ===  b.qc?.qcmember?.id;
              })?.length;
              data.capacity = data.dailytarget - data.allocate;
            }
            data.issued = bookinglist.value.filter((b: Booking) => {
                 return f.id ===  b.qc?.qcmember?.id && b.issued;
              })?.length;
            data.outstanding = bookinglist.value.filter((b: Booking) => {
                return f.id ===  b.qc?.qcmember?.id && !b.issued;
            })?.length;
            const jobtypeArray = ["inventory", "checkin", "soc", "property visit", "checkout"];
            data.cosoc = bookinglist.value.filter((b: Booking) => {
              return b.jobtype === ('checkout' || b.jobtype === 'soc') && f.id ===  b.qc?.qcmember?.id;
            })?.length;
            data.ci = bookinglist.value.filter((b: Booking) => {
              return b.jobtype === 'checkin' && f.id ===  b.qc?.qcmember?.id;
            })?.length;
            data.inventory = bookinglist.value.filter((b: Booking) => {
              return b.jobtype === 'inventory' && f.id ===  b.qc?.qcmember?.id;
            })?.length;
            data.pv = bookinglist.value.filter((b: Booking) => {
              return b.jobtype === 'property visit' && f.id ===  b.qc?.qcmember?.id;
            })?.length;
            data.other = bookinglist.value.filter((b: Booking) => {
              return !jobtypeArray.includes(b.jobtype) && f.id ===  b.qc?.qcmember?.id;
            })?.length;
                      qcdailymembertarget.value.push(data);
          });
        }
      );
    }
  );
};

const editTargetData = (row: MemberSummaryData, index: number) => {
  let data = new Qcmemberdailytarget();
  data.id = row.id;
  data.date = currentdate.value;
  data.dailytarget = row.dailytarget;
  data.working = row.working;
  data.qcmember = row.qcmember;
    
  updateDailyTarget(data).then((b) => {
    let index = qcdailymembertarget.value.findIndex(
      (q: MemberSummaryData) => q.qcmember.id === b.qcmember.id
    );
    if (index !== -1) {
      qcdailymembertarget.value[index].id = b.id;
      qcdailymembertarget.value[index].date = b.date;
      qcdailymembertarget.value[index].dailytarget = b.dailytarget;
      qcdailymembertarget.value[index].working = b.working;
      qcdailymembertarget.value[index].qcmember = b.qcmember;
      qcdailymembertarget.value[index].capacity = b.dailytarget - qcdailymembertarget.value[index].allocate;
    }
  });
};
const validateInput = (row) => {
  // if (numberInput.value === '-1' || numberInput.value.includes('e')) {
  //   numberInput.value = 0;
  // }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-icon dx-item dx-buttongroup-item dx-item-content dx-buttongroup-item-content dx-buttongroup-first-item dx-shape-standard dx-scheduler-navigator-previous",
              role: "button",
              "aria-label": "chevronprev",
              onClick: prevdate
            }, _hoisted_7),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(DxDateBox), {
                modelValue: currentdate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentdate).value = $event)),
                "display-format": "EEEE dd MMMM yyyy",
                type: "date",
                "picker-type": "calendar",
                "apply-value-mode": "instantly",
                class: "datebox",
                calendarOptions: { firstDayOfWeek: 1 }
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", {
              class: "dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-icon dx-item dx-buttongroup-item dx-item-content dx-buttongroup-item-content dx-shape-standard dx-scheduler-navigator-next",
              role: "button",
              "aria-label": "chevronnext",
              onClick: nextdate
            }, _hoisted_10),
            _createElementVNode("div", {
              class: "dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-icon dx-item dx-buttongroup-item dx-item-content dx-buttongroup-item-content dx-buttongroup-last-item dx-shape-standard today-button",
              role: "button",
              "aria-label": "today",
              onClick: today
            }, _hoisted_12)
          ])
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qcdailymembertarget.value, (row, $rowindex) => {
          return (_openBlock(), _createElementBlock("tr", { key: $rowindex }, [
            _createElementVNode("td", null, _toDisplayString(row.qcmember?.name), 1),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": ($event: any) => ((row.working) = $event),
                checked: row.working,
                onChange: ($event: any) => (editTargetData(row, $rowindex))
              }, null, 40, _hoisted_15), [
                [_vModelCheckbox, row.working]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((row.dailytarget) = $event),
                type: "number",
                class: "form-control height-43",
                onInput: ($event: any) => (validateInput(row)),
                onChange: ($event: any) => (editTargetData(row, $rowindex))
              }, null, 40, _hoisted_16), [
                [
                  _vModelText,
                  row.dailytarget,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", null, _toDisplayString(row.capacity), 1),
            _createElementVNode("td", null, _toDisplayString(row.allocate), 1),
            _hoisted_17,
            _createElementVNode("td", null, "Cosoc - " + _toDisplayString(row.cosoc) + " , CI - " + _toDisplayString(row.ci) + " , PV - " + _toDisplayString(row.pv) + ", Other - " + _toDisplayString(row.other), 1),
            _createElementVNode("td", null, _toDisplayString(row.issued), 1),
            _createElementVNode("td", null, _toDisplayString(row.outstanding), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})